// Estilos dos controles e minimapa do diagrama
const styles = (theme) => ({
  // Fundo e contorno do minimapa
  miniMap: {
    backgroundColor: theme?.palette?.background?.paper,
    border: `1px solid ${theme?.palette?.divider}`,
    borderRadius: theme?.shape?.borderRadius,
  },
  // Pilha de controles flutuantes no canto inferior direito
  floatingControlsStack: {
    position: "absolute",
    bottom: 15,
    right: 15,
    zIndex: 5,
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-end",
    gap: 1,
  },
  // Remove o posicionamento próprio do React Flow para os itens participarem da pilha
  controlsInStack: {
    position: "static",
    margin: 0,
  },
});

export default styles;
